export default __webpack_public_path__ + "static/media/Wealth-Plus-Brochure.2028ec03.pdf";